import { getAllPointClouds } from "api/timeline";
export const getPointCloudData = async(setSelectedValues:any)=>{
    const response = await getAllPointClouds();
    if (response.status === 200 && response.data){
      setSelectedValues(response.data);
    }
  };